import { render, staticRenderFns } from "./AvailableBadge.vue?vue&type=template&id=4aed790d&scoped=true&"
import script from "./AvailableBadge.vue?vue&type=script&lang=js&"
export * from "./AvailableBadge.vue?vue&type=script&lang=js&"
import style0 from "./AvailableBadge.vue?vue&type=style&index=0&id=4aed790d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aed790d",
  null
  
)

export default component.exports